import React, { useEffect, useState } from 'react';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import isNull from 'lodash/isNull';
import { AutoAssignInfoModal } from './utils';

const ACKNOWLEDGE_AUTO_ASSIGNED_PC = 'ACKNOWLEDGE_AUTO_ASSIGNED_PC';
const POSTPONED = 'POSTPONED_AUTO_ASSIGNED_PC';

export default function InfoModalAutoAssignedPC(props) {
  const {
    userId,
    schoolId,
    subjectId,
    isImpersonating,
    preferences,
    savePreference,
  } = props;

  // The simple presence of the preference is enough to indicate that the user has clicked ok
  const acknowledged =
    preferences &&
    preferences.filter((p) => p.preference === ACKNOWLEDGE_AUTO_ASSIGNED_PC)
      .length > 0;

  const [isOpen, setIsOpen] = useState(false);

  // Check if the modal should open:
  // The current student is part of a school_subject in the experiment.
  // And the user have not postponed the modal on this session.
  // And the user did not already acknowledged the modal.
  useEffect(() => {
    AutoAssignInfoModal.checkFlag(`${schoolId}_${subjectId}`).then(
      (hasAutoAssignedPCs) => {
        const postponed = window.sessionStorage.getItem(POSTPONED);
        if (hasAutoAssignedPCs && isNull(postponed) && !acknowledged) {
          setIsOpen(hasAutoAssignedPCs);
        }
      },
    );
  }, []);

  // Trigger modal when users clicks on a button
  useEffect(() => {
    AutoAssignInfoModal.listen(() => {
      setIsOpen(true);
    });
  }, []);

  const focusTriggerButton = () => {
    // Trigger focus on button after everything is settled
    setTimeout(() => {
      document.getElementById('InfoModalAutoAssignedPC-Button').focus();
    }, 1);
  };

  // Closing means postponing the modal for next session
  const onPostpone = () => {
    window.sessionStorage.setItem(POSTPONED, true);
    setIsOpen(false);
    focusTriggerButton();
  };
  // Clicking OK button means we're not showing this modal anymore
  const onSuccess = () => {
    // Don't save the preference when a teacher is impersonating a student
    if (isImpersonating) {
      onPostpone();
      return;
    }

    savePreference({
      variables: {
        userId,
        preference: ACKNOWLEDGE_AUTO_ASSIGNED_PC,
        value: 'true',
      },
    }).then(() => {
      setIsOpen(false);
      focusTriggerButton();
    });
  };

  if (!isOpen) return <div />;

  return (
    <ConfirmDialog
      title="Progress Check Assignments"
      content={{ btnPrimary: 'OK', btnSecondary: 'Read Later' }}
      modalClassName="AutoAssignedPC--modal"
      onClose={onPostpone}
      onSuccess={onSuccess}
      isPrimaryBtnDisabled={false}
      size="big"
    >
      <div className="AutoAssignedPC--modal__content">
        <p className="text-gray-700 mt-0">
          You can now use Progress Checks to independently practice and help
          stay on track for the exam in this course, even if your teacher hasn’t
          assigned them.
        </p>
        <p className="text-gray-700">
          Progress Checks cover each unit in your AP class. They help identify
          your areas of strength and areas where you might need to focus more.
          When you take a multiple-choice section of a Progress Check, you’ll
          see what questions you got right, wrong, and why. You can also
          practice answering free-response questions and score yourself using
          the same scoring criteria used by teachers who score the AP Exams.
        </p>
        <p className="text-gray-700">
          When you’re ready, click on the “to-do” cards above or navigate to
          Assignments &gt; Active to get started. For now, Progress Checks are
          directly available to students in select schools and subjects.
        </p>
      </div>
    </ConfirmDialog>
  );
}
